import React from 'react';

const TicketFillOffChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M18.1 3.6v11.8L6.3 3.6h3.8s0 2.1 2 2.1 2-2.1 2-2.1zM20.6 20l-1 1-1.5-1.5h-4s0-2.1-2-2.1-2 2.1-2 2.1h-4v-12L3.4 4.8l1-1 1.7 1.7 12 12z" />
    </svg>
);

TicketFillOffChunkySvg.displayName = 'TicketFillOffChunkySvg';
export default TicketFillOffChunkySvg;
